import { createAction } from '@reduxjs/toolkit';

export const resetVideo = createAction('video/resetAll');
